import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilService} from '../../service/util.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {

  constructor(private http: HttpClient, private util: UtilService) {
  }

  ngOnInit(): void {
  }

}
